import axios from "axios";
import { getErrors } from "helpers/error";
import { serverUrl } from "services/api";

export const CREATE_SOLICITATION_CONTRACT =
	"[CREATE_SOLICITATION_CONTRACT] CREATE_SOLICITATION_CONTRACT";
export const CREATE_SOLICITATION_CONTRACT_ERROR =
	"[CREATE_SOLICITATION_CONTRACT] CREATE_SOLICITATION_CONTRACT_ERROR";
export const CREATE_SOLICITATION_CONTRACT_SUCCESS =
	"[CREATE_SOLICITATION_CONTRACT] CREATE_SOLICITATION_CONTRACT_SUCCESS";

export function createSolicitationContract(model, file, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: CREATE_SOLICITATION_CONTRACT
		});

		try {
			const { login } = getState();

			if (!model.contractReference) delete model.contractReference;

			const request = new FormData();
			request.append("data", JSON.stringify(model));
			request.append("file", file);

			let response = await axios.post(
				`${serverUrl}/contract-solicitation`,
				request,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						Authorization: "Bearer " + login.token
					}
				}
			);

			let result = response.data;
			if (result.isValid) {
				dispatch({
					type: CREATE_SOLICITATION_CONTRACT_SUCCESS
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result);

				dispatch({
					type: CREATE_SOLICITATION_CONTRACT_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: CREATE_SOLICITATION_CONTRACT_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
